const menuList = [
  {
    menuImage: "/images/food2.jpg",
    menuTitle: "Cheese Burger",
    menuDescription: `sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt molli`,
    menuPrice: "$ 35.99",
    type: "breakfast",
  },
  {
    menuImage: "/images/food1.jpg",
    menuTitle: "Pork Salad",
    menuDescription: `sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt molli`,
    menuPrice: "$ 33.99",
    type: "launch",
  },
  {
    menuImage: "/menu/dish-1.jpg",
    menuTitle: "Fruit Meal",
    menuDescription: `sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt molli`,
    menuPrice: "$ 27.99",
    type: "dinner",
  },
  {
    menuImage: "/menu/dish-2.jpg",
    menuTitle: "Berry Mesh",
    menuDescription: `sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt molli`,
    menuPrice: "$ 100.99",
    type: "drink",
  },
  {
    menuImage: "/menu/dish-3.jpg",
    menuTitle: "Pork Salad",
    menuDescription: `sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt molli`,
    menuPrice: "$ 68.99",
    type: "breakfast",
  },
  {
    menuImage: "/menu/dish-4.jpg",
    menuTitle: "Steak Dish",
    menuDescription: `sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt molli`,
    menuPrice: "$ 303.99",
    type: "launch",
  },
  {
    menuImage: "/menu/dish-5.jpg",
    menuTitle: "Hungarian Dessert",
    menuDescription: `sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt molli`,
    menuPrice: "$ 115.99",
    type: "drink",
  },
  {
    menuImage: "/menu/dish-6.jpg",
    menuTitle: "Pork Salad",
    menuDescription: `sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt molli`,
    menuPrice: "$ 25.99",
    type: "dinner",
  },
  {
    menuImage: "/instaImages/1.jpg",
    menuTitle: "Cheesey Burgers",
    menuDescription: `sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt molli`,
    menuPrice: "$ 44.99",
    type: "breakfast",
  },
  {
    menuImage: "/instaImages/4.jpg",
    menuTitle: "Liqua Fruit Drink",
    menuDescription: `sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt molli`,
    menuPrice: "$ 20.99",
    type: "launch",
  },
];

export default menuList;
